
export const getDayIndex = (dayName?: string): number => {
  if (!dayName) return 0;
  const dayMap: { [key: string]: number } = {
    sunday: 0,
    sun: 0,
    monday: 1,
    mon: 1,
    tuesday: 2,
    tue: 2,
    tues: 2,
    wednesday: 3,
    wed: 3,
    thursday: 4,
    thu: 4,
    thur: 4,
    thurs: 4,
    friday: 5,
    fri: 5,
    saturday: 6,
    sat: 6,
  };
  return dayMap[dayName.toLowerCase()] ?? 0;
};

export const formatTimeForDisplay = (time?: string): string => {
  if (!time) return "12:00 PM";

  // If time is already in the correct format, return it
  if (time.includes("AM") || time.includes("PM")) {
    return time;
  }

  // Parse 24-hour format and convert to 12-hour format
  const [hours, minutes] = time.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  return `${displayHours}:${minutes?.toString().padStart(2, "0") || "00"} ${period}`;
};
